import { render } from "./TheHeaderNaviChildOnAdmin.vue?vue&type=template&id=4b812d6a&scoped=true&ts=true"
import script from "./TheHeaderNaviChildOnAdmin.vue?vue&type=script&lang=ts"
export * from "./TheHeaderNaviChildOnAdmin.vue?vue&type=script&lang=ts"

import "./TheHeaderNaviChildOnAdmin.vue?vue&type=style&index=0&id=4b812d6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b812d6a"]])

export default __exports__